import React, {useEffect, useState} from 'react';
import {Row, Col, Container, Card, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, Input} from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import StockTransferTable from './StockTransferTable';
import StockTransferForm from './StockTransferModal';
import {getStockTransferList, deleteStockTransfer, getStockTransferById} from '../../store/StockTransfer/actions';

const StockTransfer = () => {
  document.title = 'Stock Transfer - account-books';

  const dispatch = useDispatch();
  const stockTransferResult = useSelector((state) => state.stockTransferReducer);

  const [formOpen, setFormOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  let prevDate = moment().subtract(6, 'day');
  const [date, setDate] = useState([prevDate._d, new Date()]);

  useEffect(() => {
    dispatch(getStockTransferList(date));
  }, [stockTransferResult?.delRefresh]);

  useEffect(() => {
    setRows(stockTransferResult?.stockTransferList || []);
  }, [stockTransferResult?.stockTransferList]);

  const handleAdd = () => {
    setEditData(null);
    setFormOpen(true);
  };

  const handleEdit = (row) => {
    dispatch(getStockTransferById(row.stockTransferId, (data) => {
      setEditData(data);
      setFormOpen(true);
    }));
  };

  const handleDelete = (row) => {
    setDeleteRow(row);
    setDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    dispatch(deleteStockTransfer(deleteRow));
    setDeleteModal(false);
    setDeleteRow(null);
  };

  const handleSaved = () => {
    setFormOpen(false);
    setEditData(null);
    dispatch(getStockTransferList(date));
  };

  const handleCancel = () => {
    setFormOpen(false);
    setEditData(null);
  };

  const handleDate = (e) => {
    let defDate = [prevDate._d, new Date()];
    if (e.length === 0) {
      setDate(defDate);
    } else {
      setDate(e);
    }
    if (e.length > 1) {
      dispatch(getStockTransferList(e));
    }
  };

  const handleDateClose = (e) => {
    if (e.length === 2) return;
    if (e.length === 1) {
      const defDate = [e[0], e[0]];
      setDate(defDate);
      dispatch(getStockTransferList(defDate));
    }
  };

  return (
    <>
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader>Delete Stock Transfer</ModalHeader>
        <ModalBody>Are you sure you want to delete this Stock Transfer?</ModalBody>
        <ModalFooter>
          <Button color='primary' onClick={handleConfirmDelete}>
            Delete
          </Button>{' '}
          <Button color='secondary' onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <div className='page-content'>
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem='Stock Transfer' />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {!formOpen && (
                    <>
                      <div className='row2'>
                        <div>
                          <Input
                            type='text'
                            placeholder={`${rows.length} Search...`}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className='list-search-input'
                          />
                        </div>
                        <div className='row0'>
                          <div className='w220 px-2'>
                            <Flatpickr
                              className='form-control'
                              placeholder='Date Range'
                              value={date}
                              options={{mode: 'range', disableMobile: true, dateFormat: 'd/m/Y'}}
                              onChange={(e) => handleDate(e)}
                              onClose={(e) => handleDateClose(e)}
                            />
                          </div>
                          <div>
                            <button type='button' className='btn btn-success' onClick={handleAdd}>
                              <i className='mdi mdi-plus me-1'></i>
                              <span className='deskView'>Stock Transfer</span>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div id='table-invoices-list' className='changeHeight mt-4'>
                        {rows.length > 0 ? (
                          <StockTransferTable tableData={rows} handleEdit={handleEdit} handleDelete={handleDelete} searchTerm={searchTerm} onSearch={setSearchTerm} />
                        ) : (
                          <div className='text-center mt-5 mb-4 noDAtaA'>No Data Available</div>
                        )}
                      </div>
                    </>
                  )}

                  {formOpen && (
                    <StockTransferForm
                      editData={editData}
                      onSaved={handleSaved}
                      onCancel={handleCancel}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default StockTransfer;
